<template>
  <nav>
    <v-app-bar app fixed class="white">
      <v-app-bar-nav-icon
        class="black--text"
        @click="$emit('changedrawer', !drawer)"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text--uppercase black--text" style="cursor: pointer" @click="$router.push('/')" >
        <img :src="require(`../assets/ploutus-logo-xs.png`)" class="logo-img" alt="logo"><span class="">Ploutus Holdings</span>
        <span class=""> LLC</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer
      temporary
      :value="drawer"
      @input="val => $emit('changedrawer', val)"
      app
      class="ploBlue lighten-1"
      width="100%"
    >
      <v-list nav>
        <v-subheader class="black--text">
         <v-btn
          text
          class="black--text"
          @click="drawer = !drawer"
         ><img :src="require(`../assets/ploutus-logo-xs.png`)" class="logo-img" alt="logo"><b>Main Menu</b></v-btn>
          <v-spacer></v-spacer>
          <v-icon
            medium
            class="black--text"
            @click="drawer = !drawer"
          >
            mdi-close-thick
          </v-icon>
        </v-subheader>
        <div class="menu-body">
          <div class="menu-container" >
            <div class="box tilt" v-for="(menuLink) in menuLinks" :key="menuLink.id" @click='menuLink.dialogz= true, drawer=menuLink.drawerClose'   :style="{'background': ' linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), url(' + require('../assets/' + menuLink.image +'') + ')  no-repeat center', 'backgroundSize': 'cover', 'cursor' : 'pointer'}">
              <div class="content" v-if="!menuLink.subDetails && !menuLink.sublinks">

                <h2 style="cursor: pointer" @click="$router.push(menuLink.to), drawer=false">{{menuLink.name}}</h2>
                <div v-if="menuLink.subLinks">
                  <h5 class="sublink" v-for="(sub) in menuLink.subLinks" :key="sub.id" style="cursor: pointer" @click="$router.push(sub.to)">
                    {{sub.name}}
                  </h5>
                </div>
                
              </div>

              
                    <div class="content" v-if="menuLink.subDetails">
                        <v-dialog
                        v-model="menuLink.dialogz"
                        fullscreen
                        transition="dialog-bottom-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <h2 v-bind="attrs"
                                v-on="on">{{menuLink.name}}</h2>
                            </template>
                            <v-card class="pop-body" :class="menuLink.bgClass"
                            >
                                <v-toolbar
                                dark
                                color="primary"
                                >
                                <v-btn
                                    icon
                                    dark
                                    @click="menuLink.dialogz= false"
                                >
                                    <v-icon dark>mdi-menu</v-icon>
                                </v-btn>
                                <v-toolbar-title>{{menuLink.name}}</v-toolbar-title>
                                </v-toolbar>
                                <div class="half-container">
                                    <div class="pop-half">
                                      <h4 class="inner-pop-heading">{{menuLink.name}}</h4>
                                      <p class="inner-pop-desc" v-html="menuLink.details"></p>
                                    </div>
                                    <div class="pop-half-bottom">
                                      <div class=""  v-for="(subDetail) in menuLink.subDetails" :key="subDetail.id">
                                        <div class="pop-txt-img-hldr">
                                          <v-tooltip
                                            v-model="subDetail.dialog"
                                            right
                                            max-width="400px"
                                          >
                                          <v-icon  color="white" medium class="tip-close"  @click="subDetail.dialog = false">mdi-close-circle</v-icon>
                                            <template v-slot:activator="{on}">
                                              <div class="title-btn-hldr">
                                                <h3 class="point-cursor" @click="subDetail.dialog = !subDetail.dialog">{{subDetail.name}} <v-btn
                                                  icon
                                                  v-on= "on = false"
                                                >
                                                  <v-icon class="txt-shadow" medium color="white">
                                                    {{ !subDetail.dialog ? 'mdi-chevron-right' : 'mdi-close' }}
                                                  </v-icon>
                                                </v-btn></h3>
                                                
                                              </div>
                                            </template>
                                            <div class="tooltipz">
                                              <div class="tip-box">
                                                  <div class="">
                                                      <img :src="require(`../assets/${subDetail.logo}`)" class="tip-img" :alt="`${subDetail.name}`">
                                                  </div>
                                                  <div class="tip-details">
                                                      <h4 class="tip-heading">{{subDetail.name}}</h4>
                                                      <p class="tip-text">{{subDetail.details}}</p>
                                                      <a v-if="subDetail.link" :href="`${subDetail.link}`" class="web-link" target="_blank">Visit Website</a>
                                                  </div>
                                              </div>
                                            </div>
                                          </v-tooltip>
                                          <img @click="subDetail.dialog = !subDetail.dialog" class="pop-tile point-cursor" :src="require(`../assets/${subDetail.bg}`)" :alt="`${subDetail.name}`"/>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>

                    <div class="content" v-if="menuLink.sublinks">
                      <div class="">
                            <div class="">
                            <v-dialog
                            v-model="menuLink.dialogz"
                            fullscreen
                            transition="dialog-bottom-transition"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                  <h2 v-bind="attrs"
                                    v-on="on" class="">{{menuLink.name}}</h2>
                                </template>
                                <v-card  class="pop-body" :class="menuLink.bgClass">
                                    <v-toolbar
                                    dark
                                    color="primary"
                                    >
                                    <v-btn
                                        icon
                                        dark
                                        @click="menuLink.dialogz= false"
                                    >
                                        <v-icon dark>mdi-menu</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{menuLink.name}}</v-toolbar-title>
                                    </v-toolbar>

                                    <div class="half-container">
                                      <div class="pop-half">
                                        <h4 class="inner-pop-heading">{{menuLink.name}}</h4>
                                        <p class="inner-pop-desc" v-html="menuLink.details"></p>
                                      </div>
                                      <div class="pop-half-bottom">
                                        <div class=""  v-for="(sublink) in menuLink.sublinks" :key="sublink.id">
                                          <div class="pop-txt-img-hldr">
                                          <v-tooltip
                                            v-model="sublink.dialogz"
                                            right
                                            max-width="400px"
                                          >
                                          <v-icon  color="white" medium class="tip-close"  @click="sublink.dialogz = false">mdi-close-circle</v-icon>
                                            <template v-slot:activator="{on}">
                                              <div class="title-btn-hldr">
                                                <h3 class="point-cursor" @click="sublink.dialogz = !sublink.dialogz" >{{sublink.name}}<v-btn
                                                  icon
                                                  v-on= "on = false"
                                                >
                                                  <v-icon class="txt-shadow" medium color="white">
                                                    {{ !sublink.dialogz ? 'mdi-chevron-right' : 'mdi-close' }}
                                                  </v-icon>
                                                </v-btn></h3>
                                              </div>
                                            </template>
                                            <div class="tooltipz">
                                              <div class="tip-box">
                                                <div class="tip-details">
                                                  <h4 class="tip-heading">{{sublink.name}}</h4>
                                                  <p class="tip-text">{{sublink.details}}</p>
                                                </div>
                                                <div v-for="(subDetail) in sublink.subDetails" :key="subDetail.id">
                                                  <div class="">
                                                      <img :src="require(`../assets/${subDetail.logo}`)" class="tip-img" :alt="`${subDetail.name}`">
                                                  </div>
                                                  <div class="tip-details">
                                                      <h4 class="tip-heading">{{subDetail.name}}</h4>
                                                      <p class="tip-text">{{subDetail.details}}</p>
                                                      <a v-if="subDetail.link" :href="`${subDetail.link}`" class="web-link" target="_blank">Visit Website</a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </v-tooltip>
                                          <img @click="sublink.dialogz = !sublink.dialogz" class="pop-tile point-cursor" :src="require(`../assets/${sublink.bg}`)" :alt="`${sublink.name}`"/>
                                        </div>

                                        </div>
                                      </div>
                                    </div>

                                </v-card>
                            </v-dialog>
                            </div>
                        </div>
                    </div>
            </div>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
// import Popup from "./Popup";
export default {
  components: {
    // Popup,
  },
  props:{
    drawer:{
      type: Boolean
    }
  },
  data() {
    return {
      // drawer: false,
      selectedLink: 1,
      menuLinks: [
            {
                id: 1,
                to     : '/',
                name   : 'Ploutus Holdings LLC',
                details:'',
                image:'m-hom.webp',
                dialogz: false,
                bg: '',
                drawerClose: false,
            },
            {
                id: 2,
                to     : '/about',
                name     : 'About',
                details:'',
                image:'m-abt.webp',
                dialogz: false,
                bg: '',
                drawerClose: false,
                subLinks : [
                    {
                        id: 1,
                        name : 'About Ploutus',
                        to    : '/about',
                    },
                    {
                        id: 2,
                        name : 'Our Global Presence',
                        to    : '/global',
                    },
                    {
                        id: 3,
                        name : 'CSR',
                        to    : '/csr',
                    },
                    {
                        id: 4,
                        name : 'Contact Us',
                        to    : '/contact',
                    },
                ]
            },
            {
                id:3,
                to     : '',
                name:'Healthcare',
                details:'Our goal is to make the global supply chain of essential items seamless. In recent times, we have positioned ourselves to face the challenges of the 21st century, including the COVID-19 pandemic.',
                image:'m-hoc.webp',
                dialogz: false,
                bg: 'medbg.jpg',
                bgClass:'pop-bg1',
                drawerClose: true,
                sublinks:[
                    {
                        id:1,
                        name:'Medical Supplies',
                        details:'As a response to the COVID-19 pandemic, we have combined the resources of reputable global companies and manufacturers in an effort to crossover borders and deliver fast and credible solutions to customers in every part of the globe, including governments and institutional clients. We specialize in the sourcing, trading, and distribution of premium medical supplies.',
                        image:'ms.jpg',
                        dialogz: false,
                        bg: 'tile-med1.jpg',
                        subDetails:[
                            // {
                            //     id: 1,
                            //     name:'Roma LLC',
                            //     details:'As a response to the COVID-19 pandemic, we have combined the resources of reputable global companies and manufacturers in an effort to crossover borders and deliver fast and credible solutions to customers in every part of the globe, including governments and institutional clients. We specialize in the sourcing, trading, and distribution of premium medical supplies. Founded in 2019, Roma LLC (DBA Assistive Health) specializes in medical billing and coding, and is a one-stop-shop for any medical practice management. We work with multi-specialty hospitals to solo practices with an emphasis on their increased revenue. With our experienced onsite and offshore teams, we provide a comprehensive range of customizable services. In 2020, we launched One Test for Cancer in India, and are an authorized reseller of the OneTest in India for 20/20 Genesystems. 20/20 Genesystems is a US-based cancer diagnostics company, which has been developing cancer diagnostic products since 2008. It has created proprietary tests for lung and other types of cancer and operates a CLIA certiﬁed laboratory, catering to the needs of US hospitals.',
                            //     logo:'ro.png',
                            //     link:'',
                            //     bg:'tile-inf1.jpg',
                            //     dialog:false
                            // },
                            {
                                id: 2,
                                name:'Assistive Health',
                                details:'Assistive Health, a US based company founded by a group of experienced entrepreneurs aiming to make the global supply chain of essential items seamless. Born out of the challenges of the Covid-19 pandemic, we have combined the resources of reputable global companies and manufacturers in an effort to crossover borders and deliver fast and credible solutions to customers in every part of the globe including governments and institutional clients. We specialize in the sourcing, trading and distribution of premium PPE supplies that come directly from factories.',
                                logo:'ah.png',
                                link:'https://www.assistivehealth.com/',
                                bg:'',
                                dialog:false
                            },
                        ]
                    },
                    {
                        id:2,
                        name:'Home Care',
                        details:'We provide personal care support staff through a private service provider/organization, or through your Home Care Package (HCP), for the elderly and people living with disabilities. Depending on your needs, you could receive personal care from support care staff, on shift basis (short shifts), or 24 hour care (on shift basis) as well.',
                        image:'hc.jpg',
                        dialogz: false,
                        bg: 'tile-med2.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'EMPOWER LLC',
                                details:'We provide personal care support staff through a private service provider/organization, or through your Home Care Package (HCP), for the elderly and people living with disabilities. Depending on your needs, you could receive personal care from support care staff, on shift basis (short shifts), or 24 hour care (on shift basis) as well.',
                                logo:'ph.png',
                                link:'',
                                bg:'tile-inf1.jpg',
                                dialog:false
                            },
                        ]
                    },
                ]
            },
            {
                id:4,
                to     : '',
                name:'Infrastructure & Renewable Energy',
                details:'We provide full-service general contractor, design-builder, and construction management services. We pride ourselves on being a local builder deeply rooted in the communities where we build. Our team has years of experience in the construction industry, as well as have an exemplary track record of successful projects in the education, government, healthcare, hospitality, commercial, residential, and retail sectors. We are an investor, manager, and facilitator of power generating facilities. Some of our current projects include a Vertical Farm in Bermuda and are currently in negotiations with the Governments of Ghana, Kenya, South Africa, and many other countries to set up Renewable Energy plants using Solar, waste-to-energy, Biomass, Hydro, Geothermal, and Wind.',
                image:'m-inf.webp',
                dialogz: false,
                bg: 'infbg.jpg',
                bgClass:'pop-bg2',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Transform Associates Inc.',
                        details:'Transform Associates is a full-service general contractor, design-builder and construction manager. We pride ourselves on being a local builder deeply rooted in the communities where we build and live. Our team has years of history and experience in the construction industry as well as an exemplary track record of education, government, healthcare, hospitality, mixed – use, office, residential and retail projects. At Transform we work as a team to complete projects professionally and within budget. We provide real value. We don’t cut corners nor sacrifice quality to reduce cost; rather we thoroughly analyze each project to remain on budget and on schedule.',
                        logo:'tf.png',
                        link:'http://www.transformassociatesinc.com/',
                        bg:'tile-inf1.jpg',
                        dialog:false
                    },
                    {
                        id: 2,
                        name:'ADP Consultants Inc.',
                        details:'ADP Consultants, Inc. (ADPCI) is a highly qualified A/E/C firm offering various types of horizontal and vertical construction services, development, planning, architecture, engineering, design- build, and out-sourcing services to major clients in the United States and worldwide since 2002 with demonstrated experience in the successful management and implementation of various development projects in domestic and international markets.',
                        logo:'al.png',
                        link:'https://adpconsultantsinc.com/',
                        bg:'tile-inf2.jpg',
                        dialog:false
                    },
                    {
                        id: 3,
                        name:'ADP Construction',
                        details:'ADP construction is a company reputed to put the quality of construction at the foremost. our company delivers exceptional commercial interiors construction in dc metro area. We strive for excellence in our field. Our crew is experienced and well versed in construction details and its execution.',
                        logo:'at.png',
                        link:'https://adpconstructioninc.com/',
                        bg:'tile-inf3.jpg',
                        dialog:false
                    },
                    {
                        id: 4,
                        name:'Transform Energy LLC',
                        details:'Transform Energy Services, LLC, is a member of Transform International LLC. We are based in Maryland USA with offices in New York. We are a privately owned partnership with a group turnover of approximately US $ 2 billion.',
                        logo:'te.png',
                        link:'',
                        bg:'tile-ene1.jpg',
                        dialog:false
                    },
                ]
            },
            {
                id:5,
                to     : '',
                name:'Real Estate',
                details:'We deal in real estate investment consultancy, leasing and sale of properties directly from the leading developers, to provide unique property management services to our clients. We ensure our clients  get outstanding representation in every business done. We use proactive marketing and brokerage techniques that are necessary to navigate todays` challenging real estate.',
                image:'m-res.webp',
                dialogz: false,
                bg: 'smcbg.jpg',
                bgClass:'pop-bg3',
                drawerClose: true,
                sublinks:[
                    {
                        id:1,
                        name:'Smart City',
                        details:'We do construction of gated communities for private entities to develop housing for upscale communities, providing successful projects in the education, government, healthcare, hospitality, commercial, residential, retail sectors and all social amenities.',
                        image:'sc.jpg',
                        dialogz: false,
                        bg: 'tile-rea1.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'Ploutus Holdings LLC',
                                details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                                logo:'ph.png',
                                link:'',
                                bg:'tile-inf1.jpg',
                                dialog:false
                            },
                        ]
                    },
                    {
                        id:2,
                        name:'Housing',
                        details:'With Government housing, we do development of limited scope and medium houses for governments in various nations, for their administrative staff.',
                        image:'ho.jpg',
                        dialogz: false,
                        bg: 'tile-rea2.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'Ploutus Holdings LLC',
                                details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                                logo:'ph.png',
                                link:'',
                                bg:'tile-inf1.jpg',
                                dialog:false
                            },
                        ]
                    },
                ]
            },
            {
                id:6,
                to     : '',
                name:'IT, AI & Telecom',
                details:'Our core competencies lie in Program Management, Systems Engineering / Integration, and Implementation. Our focus on outstanding customer service and timely delivery of contracted services ensures our clients of a complete life cycle system solution at a competitive cost. We have delivered multiple turnkey projects across Telecommunications and Information Technology. Our expert team provides management and leadership for projects involving all of our Technology, Engineering, and Design services.',
                image:'m-ita.webp',
                dialogz: false,
                bg: 'itabg.jpg',
                bgClass:'pop-bg4',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Young Enterprise Systems INC.',
                        details:'YES Inc. provides advanced systems engineering, professional services, information technology, and telecom solutions to State and Federal governments and commercial clients with its proven expertise in program management, systems engineering, and integration. YES Inc. is growing and currently well-positioned in its mission-critical market segments with highly successful past performance, sound technical, financial, and managerial capabilities.',
                        logo:'ye.png',
                        link:'http://yesys.com/',
                        bg:'tile-ita1.jpg',
                        dialog:false
                    },
                    {
                        id: 2,
                        name:'Caelo Communications',
                        details:'CAELO’s mission is to bring a new class of telecommunications infrastructure management and integration support service to clients and programs which combine technical expertise, program management, and innovative engineering solutions. Our strategic services cater to increased business performance by providing solutions for key metrics depending on the industry and the position of the company within the growth curve.',
                        logo:'cl.png',
                        link:'',
                        bg:'tile-tel1.jpg',
                        dialog:false
                    },
                ]
            },
            {
                id:7,
                to     : '',
                name:'Mining & Precious Metal Trading',
                details:'We mine prosperity, we are a devoted group of experts mining towards our success in East African Region, Africa. Mining gold and other precious elements that come along with raw gold ore. Our noble cause is creating employment opportunities for the local populace to give them a brilliant future. Ploutus Holdings LLC, through its subsidiary companies, is involved in the trading of gold, diamonds, and other precious metals. Our work extends to countries like the UAE, Thailand, Ghana, Kenya, and other African countries.',
                image:'m-min.webp',
                dialogz: false,
                bg: 'minbg.jpg',
                bgClass:'pop-bg5',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Goldway Precious Metal Trading LLC (UAE)',
                        details:'Goldway Precious Metal Trading LLC is based in Dubai and is a joint venture with an equal partnership with Al Amry Group of Abu Dhabi, UAE, and Ploutus Holdings LLC, USA. Its work involves trading in Gold, Diamonds, and other precious metals, with contracts to supply gold in large volumes. We have been involved in precious metal trading for over 4 years working primarily in UAE, Thailand, Ghana, Kenya, and other African countries.',
                        logo:'gw.png',
                        link:'http://www.goldway.ae/',
                        bg:'tile-min2.jpg',
                        dialog:false
                    },
                    {
                        id: 2,
                        name:'Ploutus Holdings Limited (Kenya)',
                        details:'Ploutus Holdings (Kenya) Limited was founded to source precious metals and to start on our long-term strategic goal of gold mining. Currently, we have set up a testing facility to check the purity of the gold and are also in the process of developing a gold refinery in Kenya. We currently own 3 mines in which we have deployed the latest mining equipment, and are in the process of rolling out similar equipment to some of the mines that we are partnering with. We have established an exceptional supply chain with the miners in the area and have become one of the leading buyers of gold in Kenya.',
                        logo:'pk.png',
                        link:'https://kenya.ploutus.com/',
                        bg:'tile-min1.jpg',
                        dialog:false
                    },
                    {
                        id: 3,
                        name:'Ploutus Solutions TZ Limited',
                        details:'Based in Tanzania, Ploutus Solutions TZ Limited is a company that trades in gold and other precious metals.',
                        logo:'ptz.jpg',
                        link:'',
                        bg:'tile-min3.jpg',
                        dialog:false
                    },
                ]
            },
            {
                id:8,
                to     : '',
                name:'Trading',
                details:'From unadulterated Ceylon tea from Sri Lanka to high-quality grains from Brazil,<br>we leverage our international presence to provide top quality food products.',
                image:'m-tra.webp',
                dialogz: false,
                bg: 'fnbbg.jpg',
                bgClass:'pop-bg6',
                drawerClose: true,
                sublinks:[
                    {
                        id:1,
                        name:'Baily Tea',
                        details:'',
                        image:'fb.jpg',
                        dialogz: false,
                        bg: 'tile-fnb1.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'',
                                details:'Baily Tea USA Inc was founded as a family business with a simple idea to deliver the finest purest Ceylon Tea. We offer a wide range of the highest quality Tea from Sri Lanka to you. With expertise in the fields of “Herbal Tea”, “Fruit & Flower Tea” and mastery of ‘Ceylon Black Tea’, we offer our friendship, our services, and our commitment to you. Baily Tea was established by an experienced team, with decades of experience in growing, sourcing, packing, and exporting some of the world’s finest teas. Our goal is to provide 100% pure Ceylon tea fresh from the verdant hills of Sri Lanka and give you a unique opportunity to be a part of this 150-year industry.',
                                logo:'bt.png',
                                link:'https://www.bailytea.com/',
                                bg:'tile-inf1.jpg',
                                dialog:false
                            },
                        ]
                    },
                    {
                        id:2,
                        name:'Ploutus Distributors LLC',
                        details:'',
                        image:'oc.jpg',
                        dialogz: false,
                        bg: 'tile-fnb2.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'',
                                details:'Ploutus Distributors LLC is a US-based company that has expanded its operations to ensure the adequate supply of Personal Protective Equipments (PPE), and other essential products.',
                                logo:'pdt.jpg',
                                link:'',
                                bg:'',
                                dialog:false
                            },
                        ]
                    },
                    {
                        id:3,
                        name:'Sun Resources',
                        details:'',
                        image:'oc.jpg',
                        dialogz: false,
                        bg: 'tile-fnb4.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'',
                                details:'Sun Resources Group is a leading multinational company engaged in the supply of agricultural commodities, oil & gas, coal, metals and minerals. Our global coverage is vast and our operations extend across the energy value chain, from production and mining right through to delivery to the end user. Commencing our operations in 2007 we have grown exponentially, both in terms of traded volumes and value.',
                                logo:'sur.webp',
                                link:'https://www.sunresourcesgroup.com/',
                                bg:'',
                                dialog:false
                            },
                        ]
                    },
                    {
                        id:4,
                        name:'Ploutus Restaurants LLC',
                        details:'',
                        image:'oc.jpg',
                        dialogz: false,
                        bg: 'tile-fnb5.jpg',
                        subDetails:[
                            {
                                id: 1,
                                name:'',
                                details:'Ploutus Restaurants LLC has investments in the food and beverages industry as well as various restaurants and dark kitchens.',
                                logo:'prt.jpg',
                                link:'',
                                bg:'',
                                dialog:false
                            },
                        ]
                    },
                ]
            },
            {
                id:9,
                to     : '',
                name:'Agriculture',
                details:'With our involvement in trading, and our wide scope of associations in African and Asian countries, and our network of other food trading companies, we aim to becoming the best and a major player significantly in Agriculture.',
                image:'m-agr.webp',
                dialogz: false,
                bg: 'agrbg.jpg',
                bgClass:'pop-bg7',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Ploutus Grains Brazil',
                        details:'The newest venture of the Ploutus Holdings group of companies is its involvement in the trading of grains from Brazil. With our wide range of connections in countries in Africa and Asia, as well as our network of other food trading companies, we aim to develop Ploutus Grains Brazil to be a major player in grain trading.',
                        logo:'pg.png',
                        link:'',
                        bg:'tile-agr1.jpg',
                        dialog:false
                    },
                    {
                        id: 2,
                        name:'Euroasia Agro (Pvt) Ltd',
                        details:'TThe company is absolutely committed to bringing you the highest quality and most unique planting materials. Our tissue culture laboratory has the ability to produce millions of contaminant-free elite plants for domestic & international markets. We envisage consistent quality, juvenile vigor, superior branching, and true to type plants. We have set up hardening centers in every AGRO CLIMATE ZONE in Sri Lanka in collaboration with nurseries in different parts of the country to acclimatize our plants which allow us to respond to our customers’ needs quickly. We harden all liners in sophisticated, environmentally controlled greenhouses with crop specific designs to ensure high quality.',
                        logo:'ea.png',
                        link:'https://www.euroasiaplantbiotec.com/',
                        bg:'tile-agr2.jpg',
                        dialog:false
                    },
                ]
            },
            {
                id:10,
                to     : '',
                name:'Oil & Gas',
                details:'Our Oil & Gas ventures are customer-focused and are driven by our philosophy of integrity, professionalism, and uncompromised commitment to satisfaction.',
                image:'m-oil.webp',
                dialogz: false,
                bg: 'oilbg.jpg',
                bgClass:'pop-bg8',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Ploutus Oil & Gas LLC',
                        details:'PLOUTUS OIL & GAS, LLC is a U.S./ International based company, a leader in the energy business with an expansive network of contacts. We are a new-generation and dynamic oil & gas-trading company offering world-class services to traders around the globe. PLOUTUS has the resources to address a multitude of challenges for international businesses dealing in oil & gas. Whether it is hauling, trading, storage, or power generation to LNG, let us assist your company. We have the ability to bring American technology and expertise, whether it’s oil and gas, solar energy, or water purification. Our business customers range from major multinationals and refineries to local companies.',
                        logo:'po.png',
                        link:'',
                        bg:'tile-oil1.jpg',
                        dialog:false
                    },
                    {
                        id: 2,
                        name:'Boussard Oil & Gas LLC',
                        details:'Boussard USA, LLC is a certified Maryland Limited Liability Company.  Boussard USA, LLC serves as a seller of Nigerian petroleum products.',
                        logo:'bo.png',
                        link:'',
                        bg:'tile-oil2.jpg',
                        dialog:false
                    },
                ]
            },
            {
                id:11,
                to     : '',
                name:'Transportation',
                details:'Our team has years of experience in the construction industry, as well as have an exemplary track record of successful projects in the education, government, healthcare, hospitality, commercial, residential, and retail sectors.',
                image:'m-oth.webp',
                dialogz: false,
                bg: 'othbg.jpg',
                bgClass:'pop-bg9',
                drawerClose: true,
                subDetails:[
                    {
                        id: 1,
                        name:'Ploutus Holdings LLC',
                        details:'Ploutus Holdings LLC is a dynamic and multifaceted international organization with a plethora of services and years of experience. We lay down strong foundations for a better tomorrow, providing profitable solutions to the toughest challenges. From Kenya to Sri Lanka, we have a long list of successfully completed projects. Ploutus Holdings LLC has many different subsidiaries associated with it, with projects including contracting services, telecommunications services, business IT solutions for government and commercial clients, tea production and distribution, real estate development, renewable power generation, health care projects, CSR projects, and more.',
                        logo:'ph.png',
                        link:'',
                        bg:'tile-oth1.jpg',
                        dialog:false
                    },
                    // {
                    //     id: 2,
                    //     name:'Soleil Motors',
                    //     details:'Soleil Motors aims to provide a very bespoke program for clients focusing on attention to personal detail. Therefore each Anadi is built to order with an extensive learning process between Soleil and the new owner. Such a program ensures that each owner is fully satisfied with his or her investment.',
                    //     logo:'sm.png',
                    //     link:'http://www.soleilmotors.com/',
                    //     bg:'tile-oth2.jpg',
                    //     dialog:false
                    // },
                ]
            },
        ],
      links: [
    {
        to     : '/',
        icon   : 'mdi-home',
        text   : 'Home',
    },
    {
        icon     : 'mdi-information-variant',
        text     : 'About',
        subLinks : [
            {
                text : 'About Ploutus',
                to    : '/about',
                icon  : 'mdi-account-group'
            },
            {
                text : 'Our Global Presence',
                to    : '/global',
                icon  : 'mdi-earth'
            },
        ]
    },
    {
        to     : '/sectors',
        icon     : 'mdi-view-dashboard-variant',
        text     : 'Sectors',
    },
    {
        to     : '/csr',
        icon   : 'mdi-handshake',
        text   : 'CSR',
    },
    {
        to     : '/contact',
        icon   : 'mdi-map-marker',
        text   : 'Contact Us',
    },
]
    };
  },
  name: "Navbar",
  mounted(){

        var VanillaTilt=function(){"use strict";class t{constructor(e,i={}){if(!(e instanceof Node))throw"Can't initialize VanillaTilt because "+e+" is not a Node.";this.width=null,this.height=null,this.clientWidth=null,this.clientHeight=null,this.left=null,this.top=null,this.gammazero=null,this.betazero=null,this.lastgammazero=null,this.lastbetazero=null,this.transitionTimeout=null,this.updateCall=null,this.event=null,this.updateBind=this.update.bind(this),this.resetBind=this.reset.bind(this),this.element=e,this.settings=this.extendSettings(i),this.reverse=this.settings.reverse?-1:1,this.glare=t.isSettingTrue(this.settings.glare),this.glarePrerender=t.isSettingTrue(this.settings["glare-prerender"]),this.fullPageListening=t.isSettingTrue(this.settings["full-page-listening"]),this.gyroscope=t.isSettingTrue(this.settings.gyroscope),this.gyroscopeSamples=this.settings.gyroscopeSamples,this.elementListener=this.getElementListener(),this.glare&&this.prepareGlare(),this.fullPageListening&&this.updateClientSize(),this.addEventListeners(),this.updateInitialPosition()}static isSettingTrue(t){return""===t||!0===t||1===t}getElementListener(){if(this.fullPageListening)return window.document;if("string"==typeof this.settings["mouse-event-element"]){const t=document.querySelector(this.settings["mouse-event-element"]);if(t)return t}return this.settings["mouse-event-element"]instanceof Node?this.settings["mouse-event-element"]:this.element}addEventListeners(){this.onMouseEnterBind=this.onMouseEnter.bind(this),this.onMouseMoveBind=this.onMouseMove.bind(this),this.onMouseLeaveBind=this.onMouseLeave.bind(this),this.onWindowResizeBind=this.onWindowResize.bind(this),this.onDeviceOrientationBind=this.onDeviceOrientation.bind(this),this.elementListener.addEventListener("mouseenter",this.onMouseEnterBind),this.elementListener.addEventListener("mouseleave",this.onMouseLeaveBind),this.elementListener.addEventListener("mousemove",this.onMouseMoveBind),(this.glare||this.fullPageListening)&&window.addEventListener("resize",this.onWindowResizeBind),this.gyroscope&&window.addEventListener("deviceorientation",this.onDeviceOrientationBind)}removeEventListeners(){this.elementListener.removeEventListener("mouseenter",this.onMouseEnterBind),this.elementListener.removeEventListener("mouseleave",this.onMouseLeaveBind),this.elementListener.removeEventListener("mousemove",this.onMouseMoveBind),this.gyroscope&&window.removeEventListener("deviceorientation",this.onDeviceOrientationBind),(this.glare||this.fullPageListening)&&window.removeEventListener("resize",this.onWindowResizeBind)}destroy(){clearTimeout(this.transitionTimeout),null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.reset(),this.removeEventListeners(),this.element.vanillaTilt=null,delete this.element.vanillaTilt,this.element=null}onDeviceOrientation(t){if(null===t.gamma||null===t.beta)return;this.updateElementPosition(),this.gyroscopeSamples>0&&(this.lastgammazero=this.gammazero,this.lastbetazero=this.betazero,null===this.gammazero?(this.gammazero=t.gamma,this.betazero=t.beta):(this.gammazero=(t.gamma+this.lastgammazero)/2,this.betazero=(t.beta+this.lastbetazero)/2),this.gyroscopeSamples-=1);const e=this.settings.gyroscopeMaxAngleX-this.settings.gyroscopeMinAngleX,i=this.settings.gyroscopeMaxAngleY-this.settings.gyroscopeMinAngleY,s=e/this.width,n=i/this.height,l=(t.gamma-(this.settings.gyroscopeMinAngleX+this.gammazero))/s,a=(t.beta-(this.settings.gyroscopeMinAngleY+this.betazero))/n;null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.event={clientX:l+this.left,clientY:a+this.top},this.updateCall=requestAnimationFrame(this.updateBind)}onMouseEnter(){this.updateElementPosition(),this.element.style.willChange="transform",this.setTransition()}onMouseMove(t){null!==this.updateCall&&cancelAnimationFrame(this.updateCall),this.event=t,this.updateCall=requestAnimationFrame(this.updateBind)}onMouseLeave(){this.setTransition(),this.settings.reset&&requestAnimationFrame(this.resetBind)}reset(){this.event={clientX:this.left+this.width/2,clientY:this.top+this.height/2},this.element&&this.element.style&&(this.element.style.transform=`perspective(${this.settings.perspective}px) `+"rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)"),this.resetGlare()}resetGlare(){this.glare&&(this.glareElement.style.transform="rotate(180deg) translate(-50%, -50%)",this.glareElement.style.opacity="0")}updateInitialPosition(){if(0===this.settings.startX&&0===this.settings.startY)return;this.onMouseEnter(),this.fullPageListening?this.event={clientX:(this.settings.startX+this.settings.max)/(2*this.settings.max)*this.clientWidth,clientY:(this.settings.startY+this.settings.max)/(2*this.settings.max)*this.clientHeight}:this.event={clientX:this.left+(this.settings.startX+this.settings.max)/(2*this.settings.max)*this.width,clientY:this.top+(this.settings.startY+this.settings.max)/(2*this.settings.max)*this.height};let t=this.settings.scale;this.settings.scale=1,this.update(),this.settings.scale=t,this.resetGlare()}getValues(){let t,e;return this.fullPageListening?(t=this.event.clientX/this.clientWidth,e=this.event.clientY/this.clientHeight):(t=(this.event.clientX-this.left)/this.width,e=(this.event.clientY-this.top)/this.height),t=Math.min(Math.max(t,0),1),e=Math.min(Math.max(e,0),1),{tiltX:(this.reverse*(this.settings.max-t*this.settings.max*2)).toFixed(2),tiltY:(this.reverse*(e*this.settings.max*2-this.settings.max)).toFixed(2),percentageX:100*t,percentageY:100*e,angle:Math.atan2(this.event.clientX-(this.left+this.width/2),-(this.event.clientY-(this.top+this.height/2)))*(180/Math.PI)}}updateElementPosition(){let t=this.element.getBoundingClientRect();this.width=this.element.offsetWidth,this.height=this.element.offsetHeight,this.left=t.left,this.top=t.top}update(){let t=this.getValues();this.element.style.transform="perspective("+this.settings.perspective+"px) rotateX("+("x"===this.settings.axis?0:t.tiltY)+"deg) rotateY("+("y"===this.settings.axis?0:t.tiltX)+"deg) scale3d("+this.settings.scale+", "+this.settings.scale+", "+this.settings.scale+")",this.glare&&(this.glareElement.style.transform=`rotate(${t.angle}deg) translate(-50%, -50%)`,this.glareElement.style.opacity=`${t.percentageY*this.settings["max-glare"]/100}`),this.element.dispatchEvent(new CustomEvent("tiltChange",{detail:t})),this.updateCall=null}prepareGlare(){if(!this.glarePrerender){const t=document.createElement("div");t.classList.add("js-tilt-glare");const e=document.createElement("div");e.classList.add("js-tilt-glare-inner"),t.appendChild(e),this.element.appendChild(t)}this.glareElementWrapper=this.element.querySelector(".js-tilt-glare"),this.glareElement=this.element.querySelector(".js-tilt-glare-inner"),this.glarePrerender||(Object.assign(this.glareElementWrapper.style,{position:"absolute",top:"0",left:"0",width:"100%",height:"100%",overflow:"hidden","pointer-events":"none"}),Object.assign(this.glareElement.style,{position:"absolute",top:"50%",left:"50%","pointer-events":"none","background-image":"linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",width:`${2*this.element.offsetWidth}px`,height:`${2*this.element.offsetWidth}px`,transform:"rotate(180deg) translate(-50%, -50%)","transform-origin":"0% 0%",opacity:"0"}))}updateGlareSize(){this.glare&&Object.assign(this.glareElement.style,{width:`${2*this.element.offsetWidth}`,height:`${2*this.element.offsetWidth}`})}updateClientSize(){this.clientWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,this.clientHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight}onWindowResize(){this.updateGlareSize(),this.updateClientSize()}setTransition(){clearTimeout(this.transitionTimeout),this.element.style.transition=this.settings.speed+"ms "+this.settings.easing,this.glare&&(this.glareElement.style.transition=`opacity ${this.settings.speed}ms ${this.settings.easing}`),this.transitionTimeout=setTimeout(()=>{this.element.style.transition="",this.glare&&(this.glareElement.style.transition="")},this.settings.speed)}extendSettings(t){let e={reverse:!1,max:15,startX:0,startY:0,perspective:1e3,easing:"cubic-bezier(.03,.98,.52,.99)",scale:1,speed:300,transition:!0,axis:null,glare:!1,"max-glare":1,"glare-prerender":!1,"full-page-listening":!1,"mouse-event-element":null,reset:!0,gyroscope:!0,gyroscopeMinAngleX:-45,gyroscopeMaxAngleX:45,gyroscopeMinAngleY:-45,gyroscopeMaxAngleY:45,gyroscopeSamples:10},i={};for(var s in e)if(s in t)i[s]=t[s];else if(this.element.hasAttribute("data-tilt-"+s)){let t=this.element.getAttribute("data-tilt-"+s);try{i[s]=JSON.parse(t)}catch(e){i[s]=t}}else i[s]=e[s];return i}static init(e,i){e instanceof Node&&(e=[e]),e instanceof NodeList&&(e=[].slice.call(e)),e instanceof Array&&e.forEach(e=>{"vanillaTilt"in e||(e.vanillaTilt=new t(e,i))})}}return"undefined"!=typeof document&&(window.VanillaTilt=t,t.init(document.querySelectorAll("[data-tilt]"))),t}();
                
        VanillaTilt.init(document.querySelectorAll(".tilt"), {
		max: 25,
		speed: 400
	});
	
    }
};
</script>
<style>
.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item {
    padding-left: 8px !important;
}
.v-list-group .theme--light.v-icon {
    color: #fff !important;
}

.v-list, .v-list--nav{
  padding: 0 !important;
}

nav .v-subheader{
  height: 64px;
  background: #fff;
}

.theme--light nav .v-subheader .v-btn:focus:before, .theme--light nav .v-subheader .v-btn:hover:before, .theme--light nav .v-subheader .v-btn .v-ripple__container{
  opacity: 0;
}

.logo-img{
  width: 18px;
  margin-right: 10px;
}

.menu-body{
  display: flex;
  justify-content: center;
  align-self: center;
  min-height: calc(100vh - 64px);
}

.menu-container{
  position: relative;
  max-width: 1580px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: minmax(100px, auto);
  grid-auto-flow: dense;
}

.menu-container .box{
  padding: 20px;
  display: grid;
  font-size: 20px;
  place-items: baseline;
  color:#fff;
  transition: 0.5s;
  position: relative;
  transition: all 0.5s;
}

/* .menu-container .box:hover{
  background: #e91e63;
} */

.menu-container .box:hover:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 0;
  -webkit-filter: grayscale(100%) blur(2px);
  filter: grayscale(100%) blur(2px);
  transition: all 0.5s;
}

.menu-container .box:hover .content{
  color: #000;
  /*text-shadow: 2px 2px 8px #fff;*/
}

.menu-container .box .content{
  /*text-shadow: 2px 2px 8px #000;*/
  z-index: 1;
}

.menu-container .box .content h2, .menu-container .box .content h5{
  font-weight: 500;
}

.menu-container .box .content h2{
  font-size: 21px;
  font-weight: 300;
  /* backdrop-filter: blur(2px) grayscale(3%);*/
}

.menu-container .box .content .sublink{
  visibility: hidden;
  transition: all 0.5s;
}

.menu-container .box:hover .sublink{
  visibility: visible;
  transition: all 0.5s;
}

.menu-container .box:nth-child(1){
  grid-column: span 2;
  grid-row: span 1;
  cursor: default !important;
}

.menu-container .box:nth-child(2){
  grid-column: span 1;
  grid-row: span 2;
  cursor: default !important;
}

.menu-container .box:nth-child(3){
  grid-column: span 1;
  grid-row: span 1;
}

.menu-container .box:nth-child(4){
  grid-column: span 1;
  grid-row: span 2;
}

.menu-container .box:nth-child(5){
  grid-column: span 2;
  grid-row: span 2;
}

.menu-container .box:nth-child(6){
  grid-column: span 2;
  grid-row: span 1;
}

.menu-container .box:nth-child(7){
  grid-column: span 1;
  grid-row: span 1;
  place-items: end left;
}


.menu-container .box:nth-child(8){
  grid-column: span 2;
  grid-row: span 2;
}

.menu-container .box:nth-child(9){
  grid-column: span 2;
  grid-row: span 2;
  place-items: end left;
}

.menu-container .box:nth-child(10){
  grid-column: span 2;
  grid-row: span 2;
}

.menu-container .box:nth-child(11){
  grid-column: span 1;
  grid-row: span 2;
  place-items: end right;
}

.pop-body{
  position: relative;
  overflow: hidden;
}

.pop-bg{
  position: fixed; 
  top: 0; 
  left: 0; 

  /* Preserve aspect ratio */
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
  width:100%; height:100%;
  object-fit: cover;
}

.pop-bg1:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/medbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg2:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/infbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg3:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/smcbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg4:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/itabg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg5:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/minbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg6:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/fnbbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg7:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/agrbg.webp');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg8:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/oilbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg9:after{
      content:"";
      position:fixed; /* stretch a fixed position to the whole screen */
      top:0;
      height:100%; /* fix for mobile browser address bar appearing disappearing */
      left:0;
      right:0;
      z-index:-1; /* needed to keep in the background */
      background: url('~@/assets/othbg.jpg');
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.half-container{
  display: flex;
  flex-direction: column;
  color: #fff;
  padding-left: 20px;
  padding-top: 50px;
  padding-bottom: 20px;
  height: calc(100vh - 64px);
}

.pop-half{
  width: 775px;
  margin-bottom: auto;
}

.inner-pop-heading{
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  /*text-shadow: 1px 1px 2px black, 0 0 25px black, 0 0 5px black;*/
}

.inner-pop-desc{
  color: #fff;
  font-size: 20px;
  margin-top: 40px;
  /*text-shadow: 1px 1px 2px black, 0 0 25px black, 0 0 5px black;*/
  text-align: justify;
}

.pop-half-bottom{
  display: flex;
  flex-wrap: wrap;
}

.pop-txt-img-hldr{
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  width: 250px;
  height: 280px;
  justify-content: space-between;
}

.title-btn-hldr{
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.txt-shadow{
  /*text-shadow: 1px 1px 2px black, 0 0 25px black, 0 0 5px black;*/
}

.pop-tile{
  height:200px;
  width: 250px;
  border: 1px solid #ccc;
}

.v-application .v-tooltip__content {
    background: transparent;
    padding: 0;
    border: 15px solid rgba(255,255,255,0.5);
    border-radius: 12px;
    margin: 0;
    pointer-events: all;
    opacity: 1 !important;
}

.tooltipz{
    color: #000;
    background: rgba(255,255,255,0.9);
    padding: 30px 20px;
    margin: 0;
    position: relative;
}

.tip-close{
  position: absolute !important;
  top: -28px;
  right: -28px;
  z-index: 9;
  /*text-shadow: 1px 1px 2px black, 0 0 25px black, 0 0 5px black;*/
}

.title-btn-hldr h3{
  /*text-shadow: 1px 1px 2px black, 0 0 25px black, 0 0 5px black;*/
  font-size: 17px;
}

.tip-box{
  height: 300px;
  overflow-y: auto;
  padding-bottom: 20px;
}

.tip-img{
  width: 150px;
}

.tip-details{
  margin-bottom: 20px;
}

.tip-heading{
  font-size: 18px;
  margin: 10px 0;
}

.tip-text{
  margin-bottom: 0;
  font-size: 16px;
  color: #000;
}

.mar-top-15{
  margin-top: 15px;
}

.comp-img{
  width: auto;
  max-width: 100%;
}

.point-cursor{
  cursor: pointer;
}

@media screen and (max-width:1415px) {

  .menu-container .box:nth-child(3) {
    grid-column: span 2;
    grid-row: span 1;
}

.menu-container .box:nth-child(7) {
    grid-column: span 1;
    grid-row: span 2;
}

.menu-container .box:nth-child(9) {
    grid-column: span 2;
    grid-row: span 4;
}

.menu-container .box:nth-child(10) {
    grid-column: span 4;
    grid-row: span 3;
}

}

@media screen and (max-width:1215px) {

.menu-container .box:nth-child(1) {
    grid-column: span 2;
    grid-row: span 2;
}

.menu-container .box:nth-child(4) {
    grid-column: span 1;
    grid-row: span 1;
}

.menu-container .box:nth-child(7) {
    grid-column: span 1;
    grid-row: span 4;
}

.menu-container .box:nth-child(10) {
    grid-column: span 5;
    grid-row: span 3;
}

.menu-container .box:nth-child(11) {
    grid-column: span 3;
    grid-row: span 3;
}

}

@media screen and (max-width:1015px) {

  .menu-body{
    min-height:auto;
  }

  .menu-container{
    /*grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    grid-template-rows: minmax(auto, auto);*/
    grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
    grid-template-rows: repeat(auto-fill, minmax(65px, 1fr));
  }

  .menu-container .box{
    grid-column: unset !important;
    grid-row: span 2 !important;
    padding: 10px;
    font-size: 17px;
    min-height: 130px;
  }

  .menu-container .box:nth-child(1), .menu-container .box:nth-child(4), .menu-container .box:nth-child(7) {
    grid-column: span 2 !important;
  }

  .menu-container .box:nth-child(2), .menu-container .box:nth-child(3){
    grid-row: span 2 !important;
  }

  .menu-container .box .content h2 {
    font-size: 18px;
  }

  .menu-container .box .content .sublink{
    visibility: visible !important;
  }

  .half-container{
    padding: 20px 10px;
    height: auto;
  }

  .pop-half{
    max-width: 100%;
    margin-bottom: auto;
  }

  .inner-pop-desc{
    text-align: left;
  }

}

@media screen and (max-width:600px) {


  .menu-container .box{
    place-items: flex-start !important;
  }

  .menu-container .box:nth-child(8), .menu-container .box:nth-child(9), .menu-container .box:nth-child(10), .menu-container .box:nth-child(11) {
    place-items: end left !important;
    grid-row: span 2 !important;
  }

.menu-container .box:nth-child(4) .content, .menu-container .box:nth-child(7) .content {
    margin-right: 190px;
  }

    .menu-container {
      padding-bottom: 110px;
      background: #fff;
  }

  .menu-container .box:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  .half-container {
      width: auto;
  }

  .pop-half-bottom {
    flex-direction: column;
  }

  .tip-box {
    width: 235px;
  }

  .pop-bg1:after{
      background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('~@/assets/medbg.jpg') right -300px center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg2:after{
      
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('~@/assets/infbg.jpg') -600px center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg3:after{
      background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('~@/assets/smcbg.jpg') center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg4:after{
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('~@/assets/itabg.jpg') center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg5:after{
      background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('~@/assets/minbg.jpg') right -300px center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg6:after{
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('~@/assets/fnbbg.jpg') right center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg7:after{
      background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('~@/assets/agrbg.jpg') right center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg8:after{
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('~@/assets/oilbg.jpg') center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

.pop-bg9:after{
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('~@/assets/othbg.jpg') right -200px center no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
}

}

</style>